import { useState, useRef } from 'react'
import {
  EXTENSOES_ACEITAS, abrirAnexo, camposAnexo, enviarArquivo,
  removerArquivoSeOrfao, rotuloAnexo, temAnexo, urlValida,
} from '../lib/anexos'

const MESES = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez']

// Clipe por mes no grid de resultados. O grid tem 12 colunas, entao o gatilho
// e' minimo e todo o resto acontece num modal — mesma logica do botao de FCA.
export default function AnexoMes({ resultado, mesAnterior, indicador, ano, podeEditar, onSalvar }) {
  const [aberto, setAberto] = useState(false)
  const [link, setLink] = useState('')
  const [erro, setErro] = useState(null)
  const [ocupado, setOcupado] = useState(false)
  const inputArquivo = useRef(null)

  const anexado = temAnexo(resultado)

  async function abrir() {
    const { error } = await abrirAnexo(resultado)
    if (error) setErro(error)
  }

  async function gravar(campos, pathAntigo) {
    setOcupado(true)
    setErro(null)
    const { error } = await onSalvar(resultado.mes, campos)
    if (error) {
      setErro(error)
      setOcupado(false)
      return
    }
    // So' depois de a linha nao referenciar mais o arquivo antigo.
    if (pathAntigo && pathAntigo !== campos.anexo_path) {
      await removerArquivoSeOrfao(pathAntigo, { exceto: resultado.id })
    }
    setOcupado(false)
    setLink('')
    setAberto(false)
  }

  async function handleArquivo(e) {
    const arquivo = e.target.files?.[0]
    e.target.value = ''
    if (!arquivo) return
    setOcupado(true)
    setErro(null)
    const envio = await enviarArquivo({
      arquivo, companyId: indicador.company_id, indicadorId: indicador.id,
      ano, mes: resultado.mes,
    })
    if (envio.error) {
      setErro(envio.error)
      setOcupado(false)
      return
    }
    await gravar(camposAnexo({ tipo: 'arquivo', path: envio.path, nome: envio.nome }), resultado.anexo_path)
  }

  function handleLink() {
    if (!urlValida(link)) {
      setErro('O link precisa começar com http:// ou https://')
      return
    }
    const nome = link.trim().replace(/^https?:\/\//i, '').split('/')[0]
    gravar(camposAnexo({ tipo: 'link', url: link.trim(), nome }), resultado.anexo_path)
  }

  function handleRepetir() {
    const campos = mesAnterior.anexo_tipo === 'link'
      ? camposAnexo({ tipo: 'link', url: mesAnterior.anexo_url, nome: mesAnterior.anexo_nome })
      : camposAnexo({ tipo: 'arquivo', path: mesAnterior.anexo_path, nome: mesAnterior.anexo_nome })
    gravar(campos, resultado.anexo_path)
  }

  return (
    <>
      <button
        onClick={() => (podeEditar ? setAberto(true) : abrir())}
        title={anexado ? rotuloAnexo(resultado) : 'Anexar planilha'}
        style={{
          marginTop: 3, width: '100%', fontSize: 10, padding: '2px 0',
          background: anexado ? 'var(--blue-bg)' : 'transparent',
          color: anexado ? '#1e40af' : 'var(--text3)',
          border: `1px solid ${anexado ? 'var(--blue-border)' : 'var(--border)'}`,
          borderRadius: 4, cursor: 'pointer', textAlign: 'center',
          fontFamily: 'var(--font)', fontWeight: 500,
        }}
      >
        {anexado ? '📎 ver' : '📎'}
      </button>

      {aberto && (
        <div
          onClick={() => !ocupado && setAberto(false)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,.35)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50,
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: 'var(--surface)', border: '1px solid var(--border)',
              borderRadius: 10, padding: 20, width: 420, maxWidth: '92vw',
              boxShadow: 'var(--shadow)', textAlign: 'left',
            }}
          >
            <div style={{ fontSize: 12, color: 'var(--text2)' }}>
              Planilha de estratificação — {MESES[resultado.mes - 1]}/{ano}
            </div>
            <div style={{ fontSize: 14, fontWeight: 600, marginTop: 2, marginBottom: 14 }}>
              {indicador.nome}
            </div>

            {anexado && (
              <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                gap: 10, padding: '8px 10px', marginBottom: 14,
                background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 6,
              }}>
                <span style={{ fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {resultado.anexo_tipo === 'link' ? '🔗' : '📄'} {rotuloAnexo(resultado)}
                </span>
                <span style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  <button className="btn btn-sm" onClick={abrir} disabled={ocupado}>Abrir</button>
                  <button
                    className="btn btn-sm"
                    disabled={ocupado}
                    onClick={() => gravar(camposAnexo(null), resultado.anexo_path)}
                    style={{ color: 'var(--red)' }}
                  >
                    Remover
                  </button>
                </span>
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div>
                <label style={{ fontSize: 12 }}>Enviar arquivo</label>
                <input
                  ref={inputArquivo} type="file" accept={EXTENSOES_ACEITAS}
                  onChange={handleArquivo} disabled={ocupado}
                  style={{ fontSize: 12 }}
                />
                <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 2 }}>
                  .xlsx, .xls, .csv ou .pdf — até 10 MB
                </div>
              </div>

              <div>
                <label style={{ fontSize: 12 }}>Ou colar link</label>
                <div style={{ display: 'flex', gap: 6 }}>
                  <input
                    value={link} onChange={e => { setLink(e.target.value); setErro(null) }}
                    placeholder="https://docs.google.com/..." disabled={ocupado}
                    style={{ fontSize: 12 }}
                  />
                  <button className="btn btn-sm" onClick={handleLink} disabled={ocupado || !link.trim()}>
                    Salvar
                  </button>
                </div>
              </div>

              {temAnexo(mesAnterior) && (
                <button className="btn btn-sm" onClick={handleRepetir} disabled={ocupado}>
                  Repetir de {MESES[mesAnterior.mes - 1]}
                </button>
              )}
            </div>

            {erro && (
              <div style={{ fontSize: 12, color: 'var(--red)', marginTop: 12 }}>⚠ {erro}</div>
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
              <button className="btn btn-sm" onClick={() => setAberto(false)} disabled={ocupado}>
                {ocupado ? 'Salvando...' : 'Fechar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
